import { defineComponent as _defineComponent } from 'vue'
import {FFBorrower} from '@/models/ExpertState';
import SimulationFormStep3 from '@/components/calculator/form/SimulationFormStep3.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormStep3Wrapper',
  props: {
    borrower: null
  },
  setup(__props: any) {



return { __sfc: true,SimulationFormStep3 }
}

})